import { greenTickImage, unTickImage } from "assets/images"

// Helper to build pdfmake content for inspection sections
export function buildInspectionSectionsContent(
  inspectionSections,
  inspectionDetails,
  getGlobalIndex
) {
  const content = []

  inspectionSections.forEach((section, secIdx) => {
    const metrics =
      inspectionDetails?.check_metrics?.[section.checkMetricIndex]?.section
        ?.parameters || []

    if (!section.data || !section.data.length) return

    // Section title
    content.push({
      text: section.title?.toUpperCase() ?? "",
      style: "sectionHeader",
      margin: [0, secIdx === 0 ? 0 : 16, 0, 18],
    })

    function g0etTableValueContent(value) {
      const isEmpty = !value
      const content = []

      // Add the text with underline
      content.push({
        text: value ?? "",
        style: "tableValue",
        decoration: "underline", // underline the text
      })

      // If empty, add a full-width line
      if (isEmpty) {
        content.push({
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: "100%",
              y2: 0,
              lineWidth: 1,
            },
          ],
          margin: [0, 2, 0, 0],
        })
      }

      return content
    }
    if (section.isSub) {
      // SubHead sections
      section.data.forEach((sub, subHeadIdx) => {
        content.push({
          text: sub.title,
          style: "sectionHeader",
          margin: [0, 8, 0, 4],
        })

        const tableBody = sub.item.map((item, itemIdx) => [
          // {
          //   text: `${getGlobalIndex(secIdx, subHeadIdx, itemIdx)}. `,
          //   // style: "tableIndex",
          // },
          {
            colSpan: 2,
            columns: [
              {
                width: "auto",
                text: `${getGlobalIndex(secIdx, subHeadIdx, itemIdx)}.`,
                style: "tableItem",
              },
              {
                width: "*",
                text: item,
                style: "tableItem",
                margin: [4, 0, 0, 2], // gives space between number and text
              },
            ],
            margin: [0, 0, 0, 8],
          },
          {},
          // {
          //   text: [
          //     { text: `${getGlobalIndex(secIdx, subHeadIdx, itemIdx)}. ` }, // add a space after the dot
          //   ],
          // },
          // { text: item, style: "tableItem", margin: [0, 0, 0, 2] },
          {
            columns: [
              {
                text: ": Good",
                style: "tableGood",
                width: 40,
              },
              {
                image:
                  metrics?.[subHeadIdx]?.sub_parameters?.[itemIdx]?.status ===
                    true
                    ? greenTickImage
                    : unTickImage,
                height:
                  metrics?.[subHeadIdx]?.sub_parameters?.[itemIdx]?.status ===
                    true
                    ? 15
                    : 12,
                width:
                  metrics?.[subHeadIdx]?.sub_parameters?.[itemIdx]?.status ===
                    true
                    ? 15
                    : 12,
                margin: [0, 0, 10, 0],
                // columnGap: 10,
              },
            ],
            margin: [0, 0, 0, 8],
          },
          {
            text: metrics?.[subHeadIdx]?.sub_parameters?.[itemIdx]?.value ?? "",
            style: "tableValue",
            margin: [2, 0, 0, 8],

            bold: true,
            fontSize: 11,
          },
        ])

        content.push({
          table: {
            widths: [20, 160, 65, "*"],
            body: [
              [
                { text: "", style: "tableHeader" },
                { text: "", style: "tableHeader" },
                { text: "", style: "tableHeader" },
                { text: "", style: "tableHeader" },
              ],
              ...tableBody,
            ],
          },
          layout: "headerLineOnly",
          margin: [0, 0, 10, 8],
        })
      })
    } else {
      // Flat sections
      const tableBody = section.data.map((item, index) => [
        // {
        //   text: `${getGlobalIndex(secIdx, undefined, index)}.`,
        //   // style: "tableIndex",
        // },
        // { text: item, style: "tableItem", margin: [0, 0, 0, 2] },
        {
          colSpan: 2,
          columns: [
            {
              width: "auto",
              text: `${getGlobalIndex(secIdx, undefined, index)}.`,
              style: "tableItem",
            },
            {
              width: "*", // this is the one you want to make wider
              text: item,
              style: "tableItem",
              margin: [4, 0, 0, 2],
            },
          ],
          margin: [0, 0, 0, 8],
        },
        {},
        {
          columns: [
            { text: ": Good", style: "tableGood", width: 40 },
            {
              image:
                metrics?.[index]?.status === true
                  ? greenTickImage
                  : unTickImage,
              height: metrics?.[index]?.status === true ? 15 : 12,
              width: metrics?.[index]?.status === true ? 15 : 12,
              margin: [0, 0, 10, 0],
            },
          ],
          margin: [0, 0, 0, 8],
        },
        {
          text: metrics?.[index]?.value || "",
          style: "tableValue",
          margin: [2, 0, 0, 8],
          bold: true,
          fontSize: 11,
          // decoration: "underline",
          // borderBottom: [false, false, false, true],
        },
      ])

      content.push({
        table: {
          widths: [20, 160, 65, "*"],
          body: [
            [
              { text: "", style: "tableHeader" },
              { text: "", style: "tableHeader" },
              { text: "", style: "tableHeader" },
              { text: "", style: "tableHeader" },
            ],
            ...tableBody,
          ],
        },
        layout: "headerLineOnly",
        margin: [0, 0, 0, 8],
      })
    }
  })

  return content
}
